module.exports = __webpack_public_path__ + "static/media/gensuite-logo-charcoal.7b0c7883.svg";